import { kanbify } from './kanbifyClient'

export const STEP_IMAGE_ACCEPT = 'image/png,image/jpeg,image/webp,image/gif'
export function validateStepImage(file) {
    if (!['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(file.type)) return 'Alege o imagine PNG, JPG, WebP sau GIF.'
    if (file.size > 10 * 1024 * 1024) return 'Imaginea poate avea maximum 10 MB.'
    return null
}

export async function uploadStepImage(procedureId, file) {
    const error = validateStepImage(file)
    if (error) throw new Error(error)
    const extension = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp', 'image/gif': 'gif' }[file.type]
    const path = `${procedureId}/steps/${crypto.randomUUID()}.${extension}`
    const bucket = kanbify.storage.from('procedure-attachments')
    const result = await bucket.upload(path, file)
    if (result.error) throw new Error(result.error.message)
    const { data } = bucket.getPublicUrl(path)
    return { id: crypto.randomUUID(), name: file.name, type: file.type, url: data.publicUrl }
}
